import { CurrencySymbol, Prisma } from 'database';
import { useNumberFormatter } from '../hooks/useNumberFormatter';

// Los montos llegan como Prisma.Decimal en el tipo (string en runtime tras JSON).
type Amount = Prisma.Decimal | string | number | null;

// Celda de importe de una orden en listados: cada fila trae su propia moneda.
export const OrderAmountCell = ({
  amount,
  currency,
}: {
  amount: Amount;
  currency: CurrencySymbol | null;
}) => {
  const { formatNumber } = useNumberFormatter(currency ?? undefined);

  return (
    <span className='whitespace-nowrap tabular-nums'>
      {amount == null ? '—' : formatNumber(amount.toString())}
    </span>
  );
};
